import axios from 'axios';

export default class NewsletterService {
    doSubscribe(email) {
        const data = {email};
        return axios.post(`/api/resource/newsletter`, data)
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/newsletter-service.js